import React from 'react';
import { Icon, P, type IconName } from '@fashionnovateam/nova-ui-toolkit';

type DocumentCardProps = {
  icon: IconName;
  title: string;
  description: string;
  children: React.ReactNode;
  'data-testid'?: string;
};

export function DocumentCard({
  icon,
  title,
  description,
  children,
  'data-testid': dataTestId,
}: DocumentCardProps): React.JSX.Element {
  return (
    <div
      className="bg-white border border-gray-200 rounded-lg p-6 min-h-[200px]"
      data-testid={dataTestId}
    >
      <Icon name={icon} size="24px" color="gray" className="mb-2" />
      <div className="flex flex-col">
        <P size="lg" weight="medium" className="mb-1.5">
          {title}
        </P>
        <P size="xsm" color="disabled" className="mb-4">
          {description}
        </P>
        <div className="mt-auto">{children}</div>
      </div>
    </div>
  );
}
